import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { api, globalErrorHandler } from '../../api/create-api';
import { EMPTY_GUID } from '../../Helpers/Helper';
import { makeCall } from '../../auth-utils.js';
import { AppName } from '../../App';
import { useBSToasts } from '../Shared/BSToasts';

const RegisterUser = (props) => {
    const { user } = props;
    const [hasRegistered, setHasRegistered] = useState(false);
    const isRegistered = user.id !== EMPTY_GUID;
    const [errors, addToast, removeToast] = useBSToasts([]);

    const registerUser = () => {
        makeCall(async (authHeader) => {
            let registered = true;
            addToast('Registering...', { appearance: 'info', id: 'registering-user' });
            await api.post(`api/users/`, user, {
                headers: { ...authHeader }
            })
                .catch((error) => {
                    registered = false;
                    globalErrorHandler(error, addToast)
                });

            removeToast('registering-user', () => {
                if (registered) {
                    setHasRegistered(true);
                }
            });
        });
    };

    return (<div> {isRegistered ?
        <div className="text-start">
            <strong>{user.name}</strong>, you've already been registered to be a user of {AppName}. Unfortunately, the admin users haven't assigned your access yet.
        </div>
        : hasRegistered ?
            <div>
                <p>Registered! Check back later to use {AppName}!</p>
            </div>
            :
            <div>
                <p>Unfortunately, <strong>{user.name}</strong>, you don't currently have access to {AppName}. Would you like to register?</p>
                <div className="text-end">
                    <Button color="success" onClick={registerUser}>Register</Button>
                </div>
            </div>}
        {errors}
    </div>);
};

export default RegisterUser;


// WEBPACK FOOTER //
// ./src/components/Users/RegisterUser.js